import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-4 col-md-offset-4" }
const _hoisted_3 = { class: "rgbatohex__item rgbatohex__item--top-30" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "HEX: #", -1)
const _hoisted_5 = {
  key: 0,
  class: "col-md-4 col-md-offset-4"
}
const _hoisted_6 = { class: "rgbatohex__error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.colorHex) = $event)),
            class: "rgbatohex__input rgbatohex__input--center",
            maxlength: "7",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeColorCalculatedString && _ctx.changeColorCalculatedString(...args)))
          }, null, 544), [
            [_vModelText, _ctx.colorHex]
          ])
        ])
      ]),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}